import { render, staticRenderFns } from "./HikDoorOV.vue?vue&type=template&id=0c45d6a9&scoped=true&"
import script from "./HikDoorOV.vue?vue&type=script&lang=js&"
export * from "./HikDoorOV.vue?vue&type=script&lang=js&"
import style0 from "./HikDoorOV.vue?vue&type=style&index=0&id=0c45d6a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c45d6a9",
  null
  
)

export default component.exports